import { HashRouter as Router, Routes, Route } from "react-router-dom";
import { Home } from "./Entities/Home";
import { DrJuanAbc } from "./Entities/pages/DrJuanAbc";
import { PodologoMondragon } from "./Entities/pages/PodologoMondragon";
import { CynthiaMichelle } from "./Entities/pages/CynthiaMichelle";
import { FisioTerapia } from "./Entities/pages/Fisioterapia";
import { DrLuisCabrera } from "./Entities/pages/DrLuisCabrera";
import { DrAntonioTester } from "./Entities/pages/DrAntonioTester";
import { DraLineyNolasco } from "./Entities/pages/DraLineyNolasco";
import { CitaConfirmada } from "./Entities/CitaConfirmada";
import { Consulta } from "./Entities/Consulta";
import { Physiovital } from "./Entities/pages/Physiovital";
import { App as AppProd } from "./Entities/App";
import { Inicio } from "./Entities/Inicio";
import "rsuite/dist/rsuite.min.css";
import '@coreui/coreui/dist/css/coreui.min.css'
import "./App.css";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" Component={Home} />
        <Route path="/App" Component={AppProd} />
        <Route path="/App/Inicio" Component={Inicio} />
        <Route path="/App/Inicio/Consulta" Component={Consulta} />
        <Route path="/DrJuanAbc" Component={DrJuanAbc} />
        <Route path="/PodologoMondragon" Component={PodologoMondragon} />
        <Route path="/CynthiaMichelle" Component={CynthiaMichelle} />
        <Route path="/Fisioterapia" Component={FisioTerapia}/>
        <Route path="/DrLuisCabrera" Component={DrLuisCabrera}/>
        <Route path="/DrAntonioTester" Component={DrAntonioTester} />
        <Route path="/DraLineyNolasco" Component={DraLineyNolasco}/>
        <Route path="/Physiovital" Component={Physiovital} />
        <Route path="/CitaConfirmada/:id/:phone" Component={CitaConfirmada} />
      </Routes>
    </Router>
  );
}

export default App;
